import { get } from 'lodash';

export const getAppStarted = state => get(state, 'CommonState.app.started');

export const getUpdateAvailable = state =>
  get(state, 'CommonState.app.updateAvailable');

export const getBuildDate = state => get(state, 'CommonState.app.buildDate');



// WEBPACK FOOTER //
// ./src/state/app/selectors.js